module.exports={
  "474946383961": {
    "mimeType": "image/gif",
    "extension": "gif"
  },
  "474946383761": {
    "mimeType": "image/gif",
    "extension": "gif"
  },
  "89504e470d0a1a0a": {
    "mimeType": "image/png",
    "extension": "png"
  },
  "ffd8ff": {
    "mimeType": "image/jpeg",
    "extension": "jpg"
  },
  "57454250": {
    "mimeType": "image/webp",
    "extension": "webp"
  },
  "49492a00": {
    "mimeType": "image/tiff",
    "extension": "tiff"
  },
  "4d4d002a": {
    "mimeType": "image/tiff",
    "extension": "tiff"
  },
  "424d": {
    "mimeType": "image/bmp",
    "extension": "bmp"
  },
  "000000146674797069736f6d": {
    "mimeType": "video/mp4",
    "extension": "mp4"
  },
  "000000186674797033677035": {
    "mimeType": "video/mp4",
    "extension": "mp4"
  },
  "000000146674797071742020": {
    "mimeType": "video/quicktime",
    "extension": "mov"
  },
  "1a45dfa3": {
    "mimeType": "video/webm",
    "extension": "webm"
  },
  "25504446": {
    "mimeType": "application/pdf",
    "extension": "pdf"
  }
}